module.exports = __webpack_public_path__ + "img/tt-btn.d40fb120.png";